import React from "react";
import {useAuth0} from "@auth0/auth0-react";
import {NavBar} from "./navigation/desktop/nav-bar";
import {MobileNavBar} from "./navigation/mobile/mobile-nav-bar";
import {Footer} from "./footer/mobile/footer";
import Dashboard from "../pages/Dashboard";

export const PageLayoutMobile = ({children}) => {
    const { isLoading } = useAuth0();

    return (
        <div className="page-layout-mobile-page-layout">
            {/*<NavBar/>*/}
            {!isLoading && <MobileNavBar/>}
            <div className="page-layout__content">{children}</div>
            <Footer/>
        </div>
    );
};
